













import { Component, Mixins, Prop } from "vue-property-decorator";

interface Size { width: number; height: number; }
interface Position { x: number; y: number; }

type ResizeType = "None" | "Asymmetry" | "Symmetry";

@Component({
  components: {
  }
})
export default class ResizableWrapper extends Mixins() {
  @Prop()
  width: number;
  @Prop()
  height: number;
  @Prop({ default: "None" })
  resizeV: ResizeType;
  @Prop({ default: "None" })
  resizeH: ResizeType;

  isResized: boolean;
  position: Position;
  resizedSize: Size;
  size: Size;

  data(): any {
    return {
      isResized: false,
      resizedSize: { width: this.width, height: this.height },
      size: { width: this.width, height: this.height },
    };
  }

  startResize(event: PointerEvent): void {
    this.isResized = true;
    this.position = {x: event.pageX, y: event.pageY };
  }

  resize(event: PointerEvent): void {
    if (this.isResized) {
      const movePos = {
        x: event.pageX - this.position.x,
        y: event.pageY - this.position.y,
      };
      this.resizedSize = {
        width: this.calculateLength(this.size.width, movePos.x, this.resizeH),
        height: this.calculateLength(this.size.height, movePos.y, this.resizeV),
      };
    }
  }

  stopResize(event: PointerEvent): void {
    if (this.isResized) {
      this.size = this.resizedSize;
      this.isResized = false;
    }
  }

  private calculateLength(length: number, moveLength: number, resizeType: ResizeType): number {
    switch (resizeType) {
      case "None": return length;
      case "Asymmetry": return length + moveLength;
      case "Symmetry": return length + moveLength * 2;
    }
  }
}
